export const CASES = [
  { name: "Higher Education Directory", img: "/cases/higher-ed.webp", fit: "contain", featured: true,
    metrics: [["24M+", "organic impressions"], ["110K+", "organic reach"], ["10+", "SEO keywords on the 1st page"], ["32K+", "organic impressions"]] },
  { name: "Funderland", img: "/cases/funderland.webp",
    metrics: [["8.2M+", "impressions across Google and Meta Ads"], ["1M+", "conversions"]] },
  { name: "Higher Education Directory", img: "/cases/higher-ed.webp", fit: "contain", key: "higher-ed-grid",
    metrics: [["24M+", "organic impressions"], ["110K+", "organic reach"], ["10+", "SEO keywords on the 1st page"], ["32K+", "organic impressions"]] },
  { name: "Marlay Property Group", img: "/cases/marlay.webp",
    metrics: [["111K+", "impressions"], ["60K+", "organic reach"], ["25+", "SEO keywords on the 1st page"]] },
  { name: "Keenan Auctioneers", img: "/cases/keenan.webp",
    metrics: [["40+", "keywords in 1st position"], ["35K+", "organic impressions"]] },
  { name: "Drew Consulting", img: "/cases/drew.webp",
    metrics: [["40+", "keywords ranking on the 1st page"], ["42K+", "organic impressions"]] },
  { name: "Chatty Cats Care", img: "/cases/chattycats.webp",
    metrics: [["35+", "keywords ranking"], ["41K+", "organic impressions"]] },
  { name: "Boarding School Directory", img: "/cases/boarding.webp",
    metrics: [["40+", "keywords in 1st position"], ["35K+", "organic impressions"]] },
  { name: "Braahmam International", img: "/cases/braahmam.webp",
    desc: "Perfect Digitals designed and developed Braahmam International's website, creating a modern and scalable digital presence focused on clarity, credibility and user experience for an international consulting business." },
  { name: "Chatty Cats Care", img: "/cases/chattycats-web.webp", key: "chatty-web" },
];

const V = "https://perfectdigitals.co.uk/wp-content/uploads/";
export const VIDEOS_VERTICAL = [
  ["NARS Cream", "2026/06/06-NARS-CREAM-V2.mp4"],
  ["Curle", "2026/06/07-CURLE-V2.mp4"],
  ["House of Light", "2026/06/05-House-of-light-V2.mp4"],
].map(([t, p]) => ({ title: t, src: V + p, poster: `/posters/${p.split("/").pop().replace(".mp4", ".jpg")}` }));

export const VIDEOS_WIDE = [
  ["Headphones", "2026/06/04-b-Headphones.mp4"],
  ["Zest Cold Drink", "2026/06/01-Zest-Cold-Drink.mp4"],
  ["VA Drink", "2026/06/08-VA-DRINK.mp4"],
  ["Marshall", "2026/06/02-MARSHALL.mp4"],
  ["Leather Shoe", "2026/06/03-Leather-Shoe.mp4"],
  ["Faxe Kondi Energy", "2026/06/09-FAXE-KONDI-ENERGY-DRINK.mp4"],
  ["Headphones - Girl", "2026/06/10-b-HEADPHONES-GIRL.mp4"],
  ["Haven Insurance", "2026/07/11-Haven-Insurance.mp4"],
  ["Luxury Villas", "2026/07/14-Luxury-Villas-Property-Video.mp4"],
].map(([t, p]) => ({ title: t, src: V + p, poster: `/posters/${p.split("/").pop().replace(".mp4", ".jpg")}` }));
